import { render, staticRenderFns } from "./PageGoodRanking.vue?vue&type=template&id=2715af04&scoped=true"
import script from "./PageGoodRanking.vue?vue&type=script&lang=js"
export * from "./PageGoodRanking.vue?vue&type=script&lang=js"
import style0 from "./PageGoodRanking.vue?vue&type=style&index=0&id=2715af04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2715af04",
  null
  
)

export default component.exports